import { render, staticRenderFns } from "./app_view_config.vue?vue&type=template&id=2c4e2428&scoped=true"
import script from "./app_view_config.vue?vue&type=script&lang=js"
export * from "./app_view_config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e2428",
  null
  
)

export default component.exports